/* ADD Knowledge categories */
export const ADD_BUSINESS = "ADD_BUSINESS"
export const ADD_BUSINESS_SUCCESS = "ADD_BUSINESS_SUCCESS"
export const ADD_BUSINESS_CLEAN = "ADD_BUSINESS_CLEAN"
export const ADD_BUSINESS_ERROR = "ADD_BUSINESS_ERROR"
